export enum EntityTypes {
  ORGANIZATION = 1,
  COMPANY = 2,
  BUSINESS_AREA = 3,
}
